export default (data) => Object.fromEntries(data.map((result) => [result.name || result.id, result]));
